import AbstractStonecodeFileMimeTypeModel from './AbstractStonecodeFileMimeTypeModel';

export default class StonecodeFileMimeTypeModel extends AbstractStonecodeFileMimeTypeModel {}
